<template>
  <div id="app">
    <div class="siimple-navbar">
      <div class="siimple-navbar-title">TagPlus REST API</div>
      <div class="siimple--float-right">
          <router-link :to="{name: 'root'}" :class="'siimple-navbar-item'">
            ドキュメント
          </router-link>

          <router-link :to="{name: 'usage'}" :class="'siimple-navbar-item'">
            使い方
          </router-link>
      </div>
    </div>
    <div class="siimple-content siimple-content--medium">
      <router-view></router-view>
    </div>

    <page-footer></page-footer>
  </div>
</template>

<script>
import PageFooter from './components/PageFooter'

export default {
  name: 'app',
  components: {
    PageFooter
  }
}
</script>
